


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  NewSalvageApplication,
  OdometerBrandCodes,
  TitleBrandsType,
  VehicleConditionsType
} from "@/types";
import RequestHandler, { getConfig } from "@/assets/ts/requestHandler";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import EnglishLang from "../../public/languages/English.json";
import states from "@/assets/states";
import fuelTypes from "@/assets/fuelTypes";
import smartyStreets from "@/components/smarty-streets/smarty-streets.vue";
import { NavigationGuardNext, Route } from "vue-router";
import { SmartyStreetConfig } from "@/types/smarty-streets";
import dayjs from "dayjs";
import store from "@/store";
import {
  mergePDFsAndCreateBase64,
  pdfToBuffer
} from "@/composables/usePdfMerger";
import LoadingButton from "@/components/LoadingButton.vue";

const RH = new RequestHandler();

Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave"]);
@Component({
  components: {
    smartyStreets,
    LoadingButton
  }
})
export default class SalvageApplication extends Vue {
  private currentStep = 1;
  private states = states();
  private store = store;
  private fuelTypes = fuelTypes();
  private defaultMakes: any = [];
  private makes: any = [];
  private vehicleConditions: VehicleConditionsType[] = [];
  private titleBrands = [] as string[];
  private years: string[] = this.defaultYears();
  private nextRoute: string;
  private allowNavigate = false;
  private useEnteredAddress = false;
  private odometerUnknown = false;
  private isInsuranceInformation = false;
  private configLoaded = false;
  private config: SmartyStreetConfig;
  private appConfig: any;
  private customerType = "I";
  private englishLang = EnglishLang;
  private disableMakeAndModel = false;
  private disableModelYear = false;
  private counties = [] as any;
  private submitLoader = false;
  private PurchasedOnDate = "";
  private applicationSubmitted = false;
  private odometerBrandCodes: OdometerBrandCodes[] = [];

  @Watch("newSalvageApplication.vehicle.odometerTypeCode")
  onOdometerTypeCodeChange(newOdometerTypeCode: string) {
    if (newOdometerTypeCode === "1") {
      this.odometerUnknown = true;
    } else {
      this.odometerUnknown = false;
    }
  }

  @Watch("customerType")
  onCustomerTypeChanged(newValue: string, oldValue: string) {
    this.newSalvageApplication.owners[0].customerType = newValue;
    this.newSalvageApplication.vehicle.vehicleUseCode =
      newValue === "I" ? "P" : "C";
    if (this.newSalvageApplication.owners[0].individualCustomer) {
      this.newSalvageApplication.owners[0].individualCustomer.firstName = "";
      this.newSalvageApplication.owners[0].individualCustomer.lastName = "";
    }
    if (this.newSalvageApplication.owners[0].businessCustomer) {
      this.newSalvageApplication.owners[0].businessCustomer.businessName = "";
    }
  }

  @Watch("defaultMakes")
  onDefaultMakesChange(newValue: any) {
    this.makes = newValue;
  }

  handleBeforeUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = "";
  }

  async created() {
    if (this.guestInfo.email) {
      this.newSalvageApplication.owners[0].customerEMail = this.guestInfo.email;
    }

    await Promise.all([
      this.getCounties(),
      this.getOdometerBrandCodes(),
      this.getVehicleCondition(),
      this.getMakes()
    ]).catch(() => {
      this.allowNavigate = true;
      this.$router.push({ name: "Salvage" });
      this.$root.$emit("snackbar-message", "Something went wrong");
    });
  }

  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  beforeDestroy() {
    this.store.dispatch("setDefaultState");
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    if (!to.params.isAuthenticated) {
      return next({ name: "Salvage" });
    }
    next();
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    if (this.guestInfo.token && !this.allowNavigate) {
      this.nextRoute = to.path;
      this.store.dispatch("setGlobalAlertState", {
        title: this.englishLang.salvageApplicationConfirmationTitle,
        description: this.englishLang.salvageApplicationConfirmationDescription,
        icon: "mdi-alert-circle",
        variant: "warning",
        minWidth: "450",
        actions: [
          {
            text: this.englishLang.salvageApplicationConfirmationButtonText,
            handler: () => {
              this.allowNavigate = true;
              this.store.dispatch("hideGlobalAlert");
              this.$router.push(this.nextRoute);
            },
            color: "info"
          },
          {
            text: this.englishLang
              .salvageApplicationConfirmationCancelButtonText,
            handler: () => {
              this.store.dispatch("hideGlobalAlert");
            },
            color: "black"
          }
        ]
      });
      return next(false);
    }
    next();
  }

  defaultYears() {
    const yrs: string[] = [];
    for (let i = 1885; i < new Date().getFullYear() + 2; i++) {
      yrs.push(String(i));
    }
    yrs.reverse();
    return yrs;
  }

  getFuelTypeCode(fuelType: string) {
    const fuel = this.fuelTypes.find(fuel => fuel.key === fuelType);
    return fuel ? fuel.value : "9";
  }

  get computedMakes() {
    if (!this.makes.length) return [];

    return this.makes.map((make: any) => {
      let text = "";
      if (make.makeCode === make.makeDescription) {
        text += make.makeCode;
      } else {
        if (make.makeCode && make.makeCode.length > 0) {
          text += make.makeCode;
        }
        if (make.makeDescription && make.makeDescription.length > 0) {
          if (text !== "") {
            text += " - ";
          }
          text += make.makeDescription;
        }
      }
      return {
        ...make,
        text
      };
    });
  }

  get selectedVehicleConditions() {
    return this.vehicleConditions.filter(vehicleCondition => {
      return this.titleBrands.includes(vehicleCondition.value);
    });
  }

  @Watch("odometerUnknown")
  onOdometerUnknownChanged() {
    this.newSalvageApplication.vehicle.odometerReading = null;
  }

  private newSalvageApplication: NewSalvageApplication = {
    insurance: {
      policyNo: "",
      lotNo: ""
    },
    vehicle: {
      vin: "",
      makeCode: null,
      modelCode: "",
      modelYear: null,
      odometerTypeCode: "0",
      odometerReading: null,
      vehicleUseCode: "P",
      bodyTypeCode: "  ",
      forcedVINInd: false,
      fuelTypeCode: "1",
      majorColorCode: "9",
      newUsedCode: "U",
      vehicleTypeCode: "A",
      titleBrands: [] as TitleBrandsType
    },
    owners: [
      {
        customerType: "I",
        customerEMail: "",
        customerPhone: "",
        individualCustomer: {
          firstName: "",
          lastName: ""
        },
        businessCustomer: { businessName: "" },
        physicalAddress: {
          address1: "",
          address2: "",
          city: "",
          state: "",
          postalCode: "",
          countyID: 0
        },
        mailingAddress: {
          address1: "",
          address2: "",
          city: "",
          state: "",
          postalCode: ""
        }
      }
    ],
    ownership: {
      purchaseDate: null,
      conjunctionCode: "0"
    },
    title: {
      formerTitleNo: null,
      formerTitleState: null,
      stateItemTypeID: this.guestInfo.transactionType === "Salvage" ? 140 : 130
    },
    transaction: {
      transactionTimestamp: "",
      invoiceNo: 0,
      transactionType: "O20",
      statusCode: "2"
    },
    documentLocator: {
      document: ""
    },
    printedDigitalSignature: "",
    stateWorkGroupID: null,
    incompleteStatusCode: "W",
    requestTypeID: ""
  };

  private vinModelYears = this.defaultYears();

  private handlePaste(event: any) {
    event.preventDefault();
    const pastedData = (event.clipboardData || window.Clipboard).getData(
      "text"
    );
    this.newSalvageApplication.vehicle.vin = pastedData;
    this.$nextTick(() => {
      event.target.blur();
    });
  }

  getVehicleConditionByValue(value: string) {
    let vehicleConditionText = "";
    for (const vehicleCondition of this.vehicleConditions) {
      if (vehicleCondition.value === value) {
        vehicleConditionText = vehicleCondition.text;
        break;
      }
    }
    return vehicleConditionText;
  }

  async getCounties() {
    this.counties = await RH.getCounties();
  }

  async getVehicleCondition() {
    const vehicleConditionsData = await RH.getVehicleCondition();
    this.vehicleConditions = Object.entries(vehicleConditionsData).map(
      ([lookupCode, lookupDescription]) => ({
        value: lookupCode,
        text: lookupDescription as string
      })
    );
  }

  async getMakes() {
    this.defaultMakes = await RH.getMakes();
  }

  async getOdometerBrandCodes() {
    const odometerBrandCodes = await RH.getOdometerBrandCodes();
    this.odometerBrandCodes = Object.keys(
      odometerBrandCodes
    ).map((key: string) => ({ text: odometerBrandCodes[key], value: key }));
  }

  handleVinInput(value: string) {
    this.newSalvageApplication.vehicle.vin = value.toUpperCase();
  }

  handleOdometerInput(value: string) {
    this.newSalvageApplication.vehicle.odometerReading = parseInt(value);
  }

  handleVinKeyDown(event: KeyboardEvent) {
    const regex = /^\w*$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  async populateVINData() {
    this.newSalvageApplication.vehicle.modelCode = "";
    this.newSalvageApplication.vehicle.makeCode = null;
    this.newSalvageApplication.vehicle.modelYear = null;

    if (this.newSalvageApplication.vehicle.vin === "") {
      this.years = this.defaultYears();
      this.makes = await this.defaultMakes;
      this.disableMakeAndModel = false;
      this.disableModelYear = false;
      return;
    }

    try {
      const vehicleInfo = await RH.vinDecode(
        this.newSalvageApplication.vehicle.vin
      );

      if (vehicleInfo.errorText !== undefined) {
        throw vehicleInfo;
      }

      this.vinModelYears = vehicleInfo.modelYear;
      let modelKey = "";
      if (vehicleInfo.ncicModel == "" || vehicleInfo.ncicModel == undefined) {
        modelKey = vehicleInfo.model;
      } else {
        modelKey = vehicleInfo.ncicModel;
      }
      if (modelKey.length > 3) {
        modelKey = modelKey.substring(0, 3);
      }
      this.newSalvageApplication.vehicle.modelCode = modelKey;
      this.newSalvageApplication.vehicle.fuelTypeCode = this.getFuelTypeCode(
        vehicleInfo.fuelType
      );
      this.newSalvageApplication.vehicle.makeCode = vehicleInfo.ncicMake;
      this.disableMakeAndModel = true;
      if (this.vinModelYears.length > 1) {
        this.disableModelYear = false;
        this.years = this.vinModelYears;
      } else if (this.vinModelYears.length === 0) {
        this.years = this.defaultYears();
      } else {
        this.newSalvageApplication.vehicle.modelYear = this.vinModelYears[0];
        this.disableModelYear = true;
      }
    } catch (e) {
      this.vinModelYears = this.defaultYears();
      this.makes = await this.defaultMakes;
      this.newSalvageApplication.vehicle.modelCode = "";

      this.store.dispatch("setGlobalAlertState", {
        title: this.englishLang.vinDecodeConfirmationTitle,
        description: this.englishLang.vinDecodeConfirmationDescription,
        icon: "mdi-alert-circle",
        variant: "warning",
        actions: [
          {
            text: this.englishLang.vinDecodeConfirmationButtonText,
            handler: () => {
              this.store.dispatch("hideGlobalAlert");
            },
            color: "info"
          },
          {
            text: this.englishLang.vinDecodeConfirmationCancelButtonText,
            handler: () => {
              this.newSalvageApplication.vehicle.vin = "";
              this.store.dispatch("hideGlobalAlert");
            },
            color: "black"
          }
        ]
      });

      this.disableMakeAndModel = false;
      this.disableModelYear = false;
    } finally {
      this.years = this.vinModelYears;
    }
  }

  private applicantInfo = {
    valid: true
  };

  private vehicleInfo = {
    valid: true
  };

  private documentation = {
    ownership: [] as File[],
    odometerDisclosure: [] as File[],
    powerOfAttorney: [] as File[],
    valid: true,
    errorMessage: "",
    validMimeTypes: ["application/pdf"]
  };

  private signatureForm = {
    errorMessage: "",
    showError: false,
    valid: true,
    accepted: false
  };

  private address = {
    mailingAddress: {
      address1: "",
      address2: ""
    },
    physicalAddress: {
      address1: "",
      address2: ""
    }
  };

  private smartyStreetsVuetifyProps = {
    outlined: true,
    dense: true
  };

  private emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private rules = {
    required: (value: string | number) =>
      !!value || this.englishLang.requiredErrorMessage,
    multipleRequired: (value: string[] | number[]) =>
      value.length > 0 ? true : this.englishLang.requiredErrorMessage,
    filesRequired: (files: File[]) => (files.length > 0 ? true : false),
    email: (value: string) => {
      return (
        this.emailRegex.test(value) ||
        this.englishLang.invalidEmailAddressErrorMessage
      );
    },
    phoneNumber: (value: string) =>
      value.replace(/\D/g, "").length === 10
        ? true
        : this.englishLang.invalidPhoneNumberErrorMessage,
    validateFiles: (file: File[]) => false
  };

  private async validateUserInfo() {
    if (this.applicantInfoForm.validate()) {
      this.currentStep++;
    }
  }

  private validateVehicleInfo() {
    if (this.vehicleInfoForm.validate()) {
      this.PurchasedOnDate =
        this.newSalvageApplication.ownership.purchaseDate ?? "";
      this.currentStep++;
    }
  }

  private validateFileTypes(files: File[], errorMessage: string) {
    for (const file of files) {
      if (!this.documentation.validMimeTypes.includes(file.type)) {
        this.documentation.errorMessage = errorMessage;
        return false;
      }
    }
    return true;
  }

  private validateDocumentation() {
    this.documentation.valid = false;
    const isOwnership = this.rules.filesRequired(this.documentation.ownership);
    const files = [
      ...this.documentation.ownership,
      ...this.documentation.odometerDisclosure,
      ...this.documentation.powerOfAttorney
    ];

    if (
      this.documentationForm.validate() &&
      this.rules.filesRequired(this.documentation.ownership)
    ) {
      if (
        !this.validateFileTypes(
          this.documentation.ownership,
          this.englishLang
            .salvageApplicationStep3OwnershipDocumentationErrorMessage
        ) ||
        !this.validateFileTypes(
          this.documentation.odometerDisclosure,
          this.englishLang.salvageApplicationStep3OdometerDisclosureErrorMessage
        ) ||
        !this.validateFileTypes(
          this.documentation.powerOfAttorney,
          this.englishLang.salvageApplicationStep3PowerOfAttorneyErrorMessage
        )
      ) {
        return;
      }

      const totalSize = files.reduce((sum, file) => sum + file.size, 0);
      if (totalSize > this.appConfig.salvageDocMaxSize) {
        // 1 MB = 1048576 bytes
        this.documentation.errorMessage = `Total size of selected files exceeds ${(
          this.appConfig.salvageDocMaxSize / 1048576
        ).toFixed(1)} MB.`;
        return;
      }

      this.documentation.errorMessage = "";
      this.documentation.valid = true;
      this.currentStep++;
    } else if (!isOwnership) {
      this.documentation.errorMessage = this.englishLang.salvageApplicationStep3RequiredFileErrorMessage;
    } else if (
      !this.rules.validateFiles(this.documentation.ownership) ||
      !this.rules.validateFiles(this.documentation.odometerDisclosure) ||
      !this.rules.validateFiles(this.documentation.powerOfAttorney)
    ) {
      this.documentation.errorMessage = `Only ${this.appConfig.salvageDocFilesLimit} document uploads are allowed per document type.`;
    }
  }

  private validateSignatureForm() {
    this.signatureForm.showError = false;
    this.signatureForm.valid = false;
    if (
      this.signatureForm.accepted &&
      this.newSalvageApplication.printedDigitalSignature.length > 0
    ) {
      this.signatureForm.valid = true;
      this.currentStep++;
    } else {
      this.signatureForm.errorMessage = this.englishLang.salvageApplicationStep4ErrorMessage;
      this.signatureForm.showError = true;
    }
  }

  private async handleSubmit() {
    this.submitLoader = true;
    try {
      this.newSalvageApplication.transaction.transactionTimestamp = dayjs(
        new Date()
      ).toISOString();

      if (this.newSalvageApplication.vehicle.modelYear) {
        this.newSalvageApplication.vehicle.modelYear = Number(
          this.newSalvageApplication.vehicle.modelYear
        );
      }

      if (this.odometerUnknown) {
        this.newSalvageApplication.vehicle.odometerReading = 0;
      }

      if (this.newSalvageApplication.ownership.purchaseDate) {
        this.newSalvageApplication.ownership.purchaseDate = dayjs(
          new Date(this.newSalvageApplication.ownership.purchaseDate)
        ).toISOString();
      }
      this.newSalvageApplication.owners[0].physicalAddress.address1 = this.address.physicalAddress.address1;
      this.newSalvageApplication.owners[0].physicalAddress.address2 = this.address.physicalAddress.address2;

      if (
        this.useEnteredAddress &&
        this.newSalvageApplication.owners[0].mailingAddress
      ) {
        this.newSalvageApplication.owners[0].mailingAddress.address1 = this.address.mailingAddress.address1;
        this.newSalvageApplication.owners[0].mailingAddress.address2 = this.address.mailingAddress.address2;
      } else {
        delete this.newSalvageApplication.owners[0].mailingAddress;
      }

      if (this.customerType === "I") {
        delete this.newSalvageApplication.owners[0].businessCustomer;
      } else {
        delete this.newSalvageApplication.owners[0].individualCustomer;
      }

      if (!this.isInsuranceInformation) {
        delete this.newSalvageApplication.insurance;
      }

      this.newSalvageApplication.vehicle.titleBrands = [];
      if (!this.titleBrands.includes("8")) {
        /* delete the key below, if submit api failed and then user remove Non-Repairable from vehicleConditions */
        delete this.newSalvageApplication.vehicleCondition;
      }
      this.titleBrands.forEach(titleBrandID => {
        if (titleBrandID === "8") {
          /*if Non-Repairable("8") is selected then send it as vehicleCondition */
          this.newSalvageApplication.vehicleCondition = "Total Loss";
        } else {
          this.newSalvageApplication.vehicle.titleBrands.push({ titleBrandID });
        }
      });

      this.newSalvageApplication.documentLocator.document = "";
      const files = [
        ...this.documentation.ownership,
        ...this.documentation.odometerDisclosure,
        ...this.documentation.powerOfAttorney
      ];

      const pdfBuffers: ArrayBuffer[] = await pdfToBuffer(files);
      const base64String = await mergePDFsAndCreateBase64(pdfBuffers);
      this.newSalvageApplication.documentLocator.document = base64String;

      await RH.submitSalvageApplication(this.newSalvageApplication);
      this.applicationSubmitted = true;
      window.removeEventListener("beforeunload", this.handleBeforeUnload);

      this.store.dispatch("setGlobalAlertState", {
        title: this.englishLang.salvageApplicationSuccessAlertTitle,
        description: this.englishLang.salvageApplicationSubmissionMessage1,
        description2: this.englishLang.salvageApplicationSubmissionMessage2,
        minWidth: "470",
        variant: "success"
      });
    } catch (error) {
      if ([401, 403].includes(error?.response?.status)) {
        this.store.dispatch("setGlobalAlertState", {
          title: this.englishLang.sessionTimeoutAlertTitle,
          description: this.englishLang.sessionTimeoutAlertDescription,
          variant: "error",
          actions: [
            {
              text: this.englishLang.globalAlertOkayButton,
              handler: () => {
                this.allowNavigate = true;
                this.store.dispatch("hideGlobalAlert");
                this.$router.push({ name: "Salvage" });
              },
              color: "secondary"
            }
          ]
        });
      } else if (error?.response?.status === 500) {
        this.store.dispatch("setGlobalAlertState", {
          title: this.englishLang.alertErrorTitle,
          description: this.englishLang.dbErrorDescription,
          variant: "error",
          actions: [
            {
              text: this.englishLang.globalAlertOkayButton,
              handler: () => {
                this.store.dispatch("hideGlobalAlert");
              },
              color: "secondary"
            }
          ]
        });
      } else {
        this.$root.$emit(
          "snackbar-message",
          this.englishLang.salvageApplicationValidationError
        );
      }

      if (this.newSalvageApplication.vehicle.modelYear) {
        this.newSalvageApplication.vehicle.modelYear =
          String(this.newSalvageApplication.vehicle.modelYear) ||
          Number(this.newSalvageApplication.vehicle.modelYear);
      }

      if (this.odometerUnknown) {
        this.newSalvageApplication.vehicle.odometerReading = null;
      }

      if (this.newSalvageApplication.ownership.purchaseDate) {
        this.newSalvageApplication.ownership.purchaseDate = this.newSalvageApplication.ownership.purchaseDate.split(
          "T"
        )[0];
      }
      if (!this.useEnteredAddress) {
        this.newSalvageApplication.owners[0].mailingAddress = {
          address1: "",
          address2: "",
          city: "",
          state: "",
          postalCode: ""
        };
      }
      if (this.customerType === "I") {
        this.newSalvageApplication.owners[0].businessCustomer = {
          businessName: ""
        };
      } else {
        this.newSalvageApplication.owners[0].individualCustomer = {
          firstName: "",
          lastName: ""
        };
      }
      if (!this.isInsuranceInformation) {
        this.newSalvageApplication.insurance = {
          policyNo: "",
          lotNo: ""
        };
      }
    } finally {
      this.submitLoader = false;
    }
  }

  get guestInfo() {
    return this.store.getters.getGuestInfo;
  }

  get applicationType() {
    return this.guestInfo.transactionType === "Salvage"
      ? this.englishLang.salvageApplicationType
      : this.englishLang.nonRepairableApplicationType;
  }

  get applicantInfoForm(): Vue & { validate: () => boolean } {
    return this.$refs.applicantInfoForm as Vue & { validate: () => boolean };
  }

  get vehicleInfoForm(): Vue & { validate: () => boolean } {
    return this.$refs.vehicleInfoForm as Vue & { validate: () => boolean };
  }

  get documentationForm(): Vue & { validate: () => boolean } {
    return this.$refs.documentationForm as Vue & { validate: () => boolean };
  }

  async beforeMount() {
    this.appConfig = await getConfig();
    this.newSalvageApplication.stateWorkGroupID =
      this.guestInfo.transactionType === "Salvage"
        ? this.appConfig.salvageStateWorkGroupID
        : this.appConfig.nonRepairableWorkGroupID;
    this.newSalvageApplication.requestTypeID = this.appConfig.requestTypeID;
    this.rules.validateFiles = (files: File[]) => {
      if (files.length > this.appConfig.salvageDocFilesLimit) {
        this.documentation.errorMessage = `Only ${this.appConfig.salvageDocFilesLimit} document uploads are allowed per document type.`;
        return false;
      }
      this.documentation.errorMessage = "";
      return true;
    };
  }

  async beforeCreate() {
    this.config = await RH.getSmartyStreetsConfig();
    this.configLoaded = true;
  }
}
